export { default } from "./LinkedEntity";
